import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SidebarDrawerContext = createContext({
    open: false,
    openDrawer: () => {},
    closeDrawer: () => {},
});

export function SidebarDrawerProvider({ children }) {
    const [open, setOpen] = useState(false);
    const openDrawer = useCallback(() => setOpen(true), []);
    const closeDrawer = useCallback(() => setOpen(false), []);
    const value = useMemo(() => ({ open, openDrawer, closeDrawer }), [open, openDrawer, closeDrawer]);

    return (
        <SidebarDrawerContext.Provider value={value}>
            {children}
        </SidebarDrawerContext.Provider>
    );
}

export function useSidebarDrawer() {
    return useContext(SidebarDrawerContext);
}
